import { gql } from '@apollo/client';

const GET_STUDENT_PROGRESS = gql`
  query studentProgress($where: StudentProgressDataWhereInput!) {
    studentProgress(where: $where) {
      student {
        id
      }
      characterProgress {
        characterId
        activityCompletedCount
        activityTotalCount
        bookReadCount
        activitySkippedCount
      }
    }
  }
`;

export default GET_STUDENT_PROGRESS;
